import { useEffect, useState } from 'react';
import Select from 'react-select';

const PresetDataSetSelect = ({ value, options, onSelect }) => {
  const [selected, setSelected] = useState([]);

  const onLocalChange = (data) => {
    setSelected(data.map((elm) => elm.id));
    onSelect(data.map((elm) => elm.id));
  };

  useEffect(() => {
    setSelected(value);
  }, [value]);

  return (
    <Select
      options={options || []}
      isMulti
      value={options.filter((elm) => selected.includes(elm.id))}
      getOptionValue={(elm) => elm.id}
      getOptionLabel={(elm) => elm.name}
      onChange={onLocalChange}
    />
  );
};

export default PresetDataSetSelect;
